import Cookies from "js-cookie";
import { getBaseDomain } from "helpers/index";

export const readToken: ReturnType<any> = () => {
	return Cookies.get("token");
};

export const storeToken = (token: string, rememberMe: boolean): void => {
	Cookies.set("token", token, {
		expires: rememberMe ? 7 : 1,
		domain: getBaseDomain(),
	});
};

export const removeToken: ReturnType<any> = () => {
	Cookies.remove("token", { domain: getBaseDomain() });
};
